/**
 * Small accessibility helpers for disclosures that move focus (the phone nav
 * drawer). Plain functions, so they test without a DOM library.
 */

const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',')

/** The first element inside `root` that keyboard focus can land on, or null. */
export function firstFocusable(root: ParentNode | null | undefined): HTMLElement | null {
  return root?.querySelector<HTMLElement>(FOCUSABLE) ?? null
}

/** The control that opens the element with this id (its `aria-controls` points at it), or null. */
export function controllerOf(id: string, doc: Pick<Document, 'querySelector'> = document): HTMLElement | null {
  return doc.querySelector<HTMLElement>(`[aria-controls="${id.replace(/["\\]/g, '\\$&')}"]`)
}

/**
 * Spread onto an element to take it out of interaction and the accessibility
 * tree while `on` (the content behind an open drawer). React 18 has no `inert`
 * prop; the attribute form renders on the server and the client alike.
 */
export function inertWhen(on: boolean): Record<string, string> {
  return on ? { inert: '' } : {}
}
